import { render, staticRenderFns } from "./settings_class_manual.vue?vue&type=template&id=4f64ff4a&scoped=true&"
import script from "./settings_class_manual.vue?vue&type=script&lang=js&"
export * from "./settings_class_manual.vue?vue&type=script&lang=js&"
import style0 from "./settings_class_manual.vue?vue&type=style&index=0&id=4f64ff4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64ff4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VRow})
